import { Resource } from '../../shared/resource';

export class FleetHealthStats extends Resource {
  onShiftCount: number;
  driversWithIssues: number;
  driverCount: number;
  applicationVersions: { [key: string]: number }[];
}
